export const namespaced = true;

import BookService from '@/services/BookService.js';

export const state = {
  books: [],
  bookParts: [],
  bookChapters: [],
  bookBigQuestions: [],
};

export const mutations = {
  SET_BOOKS(state, books) {
    state.books = books;
  },
  SET_BOOK_PARTS(state, bookParts) {
    state.bookParts = bookParts;
  },
  SET_BOOK_CHAPTERS(state, bookChapters) {
    state.bookChapters = bookChapters;
  },
  SET_BOOK_BIG_QUESTIONS(state, bookBigQuestions) {
    state.bookBigQuestions = bookBigQuestions;
  },
};

export const actions = {
  fetchBooks({ commit }) {
    return BookService.all().then((response) => {
      commit('SET_BOOKS', response.data);
    });
  },
  fetchBookParts({ commit }, bookId) {
    return BookService.allParts(bookId).then((response) => {
      commit('SET_BOOK_PARTS', response.data);
    });
  },
  fetchBookChapters({ commit }, payload) {
    return BookService.allChapters(payload.bookId, payload.partId).then((response) => {
      commit('SET_BOOK_CHAPTERS', response.data);
    });
  },
  fetchBookBigQuestions({ commit }, payload) {
    return BookService.allBigQuestions(payload.bookId, payload.partId, payload.chapterId).then((response) => {
      commit('SET_BOOK_BIG_QUESTIONS', response.data);
    });
  },
};

export const getters = {
  listOfBooksForTestPreparation: (state) => {
    const codeList = ['12011', '12012', '12021', '12022', '12031', '12032', '22010', '22020', '22030'];
    return state.books.filter((currentBook) => {
      return codeList.indexOf(currentBook.code) > -1;
    });
  },
};
